'use client';

import { forwardRef } from 'react';
import { cn } from '@/core/utils/cn';
import { CURRENCY_META } from '@/core/constants/currencies';

interface CurrencyInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  currency?: string;
}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ className, label, error, currency = 'INR', ...props }, ref) => {
    const symbol = CURRENCY_META[currency as keyof typeof CURRENCY_META]?.symbol ?? currency;
    return (
      <div className="space-y-1.5">
        {label && <label className="block text-[12px] font-medium text-hms-textSub">{label}</label>}
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[13px] text-hms-textDim font-medium">
            {symbol}
          </span>
          <input id="shared-currency-input-number-1"
            ref={ref}
            type="number"
            step="0.01"
            min="0"
            className={cn(
              'w-full h-9 pl-8 pr-3 text-[13px] text-hms-text bg-hms-bg border border-hms-border rounded-lg',
              'placeholder:text-hms-textDim',
              'focus:outline-none focus:ring-2 focus:ring-hms-gold/30 focus:border-hms-gold/50',
              'transition-colors duration-150',
              error && 'border-hms-red/50',
              className
            )}
            {...props}
          />
        </div>
        {error && <p className="text-[11px] text-hms-red">{error}</p>}
      </div>
    );
  }
);
CurrencyInput.displayName = 'CurrencyInput';
